export const getBaseAutomationUrl = ({ spaceKey }: { spaceKey: string }): string => {
	return `/wiki/spaces/${spaceKey}/settings/automation`;
};
